import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import SharePage from "./SharePage";

const path = window.location.pathname;
const shareMatch = path.match(/^\/s\/([A-Za-z0-9_-]+)\/?$/);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {shareMatch ? <SharePage token={shareMatch[1]} /> : <App />}
  </React.StrictMode>
);
